// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".connect-banner[data-v-41dfcf5a] {\n  font-size: 13px;\n}\n.connect-banner[data-v-41dfcf5a]:before {\n  background: #1c9dd6;\n  content: \"\";\n}", ""]);
// Exports
module.exports = exports;
